import type { tags as EN } from '../en/tags';

export const tags: Record<keyof typeof EN, string> = {
  'tags.input.placeholder': 'Schlagwort finden oder erstellen…',
  'tags.page.empty': 'Keine Seite trägt dieses Schlagwort.',

  // TagInput
  'tags.toast.invalidName': 'Ein Schlagwort braucht einen Namen mit 1–64 Zeichen.',
  'tags.addTag': 'Schlagwort hinzufügen',
  'tags.empty.none': 'Noch keine Schlagwörter.',
  'tags.empty.alreadyOn': 'Schon auf dieser Seite.',
  'tags.createTagBefore': 'Schlagwort „',
  'tags.createTagAfter': '“ erstellen',
  'tags.removeTag': 'Schlagwort {name} entfernen',

  // TagView
  'tags.loadError': 'Dieses Schlagwort konnte nicht geladen werden.',
  'tags.fallbackTitle': 'Schlagwort',
  'tags.pageCount.one': '{count} Seite',
  'tags.pageCount.other': '{count} Seiten',

  // TagsSection
  'tags.section.heading': 'Schlagwörter',
  'tags.section.empty':
    'Noch keine Schlagwörter. Füge eines über den Kopfbereich einer Seite hinzu.',
  'tags.renameAria': '{name} umbenennen',
  'tags.deleteAria': 'Schlagwort {name} löschen',
  'tags.deleteTag': 'Schlagwort löschen',
  'tags.confirmRemove.one': 'Schlagwort „{name}“ von {count} Seite entfernen?',
  'tags.confirmRemove.other': 'Schlagwort „{name}“ von {count} Seiten entfernen?',
  'tags.confirmRemove.description1': 'Die Seiten werden nicht gelöscht.',
  'tags.confirmRemove.description2': 'Nur das Schlagwort wird von ihnen entfernt.',
  'tags.removeTagAction': 'Schlagwort entfernen',
  'tags.toast.removed': 'Schlagwort „{name}“ entfernt.',

  // useTags.ts toasts
  'tags.toast.renameError': 'Das Schlagwort konnte nicht umbenannt werden.',
  'tags.toast.deleteError': 'Das Schlagwort konnte nicht gelöscht werden.',

  // Outbox entry labels
  'tags.fallbackLabel': 'Schlagwort',
  'tags.assignLabel': 'Schlagwörter',
};
